import { useContext } from "react";

import { ProfileAppContext } from "./components";
import { IProfileAppContext } from "./types";

// Utility hook.
export const useProfileAppContext = (): IProfileAppContext =>
  useContext(ProfileAppContext);
